import { Chip, emphasize, styled } from '@mui/material';

export const StyledRescuerBreadcrumb = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  height: theme.spacing(3),
  color: theme.palette.secondary.contrastText,
  fontWeight: theme.typography.fontWeightRegular,
  '&:hover, &:focus': {
    backgroundColor: theme.palette.grey[300],
  },
  '&:active': {
    boxShadow: theme.shadows[1],
    backgroundColor: emphasize(theme.palette.grey[300], 0.12),
  },
}));

export const StyledRescuerTextBreadcrumb = styled(Chip)(({ theme }) => ({
  backgroundColor: 'transparent',
  height: theme.spacing(3),
  color: theme.palette.grey[800],
  fontWeight: theme.typography.fontWeightRegular,

  '&:hover, &:focus': {
    backgroundColor: 'transparent',
  },
  '&:active': {
    boxShadow: theme.shadows[0],
    backgroundColor: 'transparent',
  },

  '& .MuiChip-label': {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));
